export default {
  TYPE: [
    { KEY: 0, VALUE: 'Passagens' },
    { KEY: 1, VALUE: 'Vendas' },
  ],
};
